import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import InformationLink from './InformationLink'

interface Props {
  employeeId: string | null | undefined
  companyId: string | null | undefined
}

const ManualLinks = ({ employeeId, companyId }: Props) => {
  const { navigation } = useNavigation()

  if (!employeeId || !companyId) {
    return null
  }
  return (
    <>
      <InformationLink
        href={`${navigation.employees.id.personal.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_profile')}
      />
      <InformationLink
        href={`${navigation.employees.id.contractVersions.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_contract')}
      />
    </>
  )
}

export default ManualLinks
